module.exports = __webpack_public_path__ + "static/media/GT-America-Condensed-Bold.aefa7565.woff";